import { AppBar, Toolbar, Link, Typography, Container, CssBaseline } from '@mui/material';
//import SignInSignOutButton from './auth/SignInSignOutButton';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/system';
import { BarChart, Today, PeopleAlt, AutoAwesomeMosaicRounded, ManageAccounts } from '@mui/icons-material';
import useStyles from '../styles/useStyles';
import { useEffect, useState } from 'react';
import { roles } from '../constants';
import useAuthGetters from '../hooks/useAuthGetters';
import { SignOutButton } from './auth/SignOutButton';
import EmployeeQueries from '../pages/management/employees/EmployeeQueries';

const NavBar: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [isManager, setIsManager] = useState(false);
  const { getApiAuth } = useAuthGetters();
  const { IsManager } = EmployeeQueries();
  let { data: manager } = IsManager();

  useEffect(() => {
    getApiAuth().then(auth => {
      if (auth.account && auth.account.idTokenClaims) {
        const claims = auth.account.idTokenClaims as { roles: string[] }; // TODO Have not verified this type
        setIsManager(claims.roles.includes(roles.MANAGER));
      } else {
        setIsManager(false);
      }
    });
  });

  const classes = useStyles();
  return (
    <Box className={classes.navBar}>
      <CssBaseline />
      <AppBar position="static">
        <Container>
          <Toolbar>
            <Typography className={classes.title} fontSize="large">
              <Link component={RouterLink} to="/" color="inherit" variant="h5" underline="none">
                PRIORITY MANAGER
              </Link>
            </Typography>
            {
              <Typography className={classes.menuButton}>
                <Link component={RouterLink} to="/timeline" color="inherit" underline="none" className={classes.hover}>
                  <BarChart fontSize="inherit" /> Timeline
                </Link>
              </Typography>
            }
            {
              /** isManager && */ <Typography className={classes.menuButton} pl={3}>
                <Link component={RouterLink} to="/display" color="inherit" underline="none" className={classes.hover}>
                  <AutoAwesomeMosaicRounded fontSize="inherit" /> Display
                </Link>
              </Typography>
            }
            {/**
              <Typography className={classes.menuButton} pl={3}>
                <Link component={RouterLink} to="/leave" color="inherit" underline="none" className={classes.hover}>
                  <Today fontSize="inherit" /> Leave
                </Link>
              </Typography>
              */}

            <Typography className={classes.menuButton} pl={3}>
              <Link component={RouterLink} to="/clients" color="inherit" underline="none" className={classes.hover}>
                <PeopleAlt fontSize="inherit" /> Clients
              </Link>
            </Typography>

            {manager && (
              <Typography className={classes.menuButton} pl={3}>
                <Link
                  component={RouterLink}
                  to="/management"
                  color="inherit"
                  underline="none"
                  className={classes.hover}
                >
                  <ManageAccounts fontSize="inherit" /> Management
                </Link>
              </Typography>
            )}
            {manager && (
              <Typography className={classes.menuButton} pl={3}>
                <Link component={RouterLink} to="/admin" color="inherit" underline="none" className={classes.hover}>
                  <AutoAwesomeMosaicRounded fontSize="inherit" /> Admin
                </Link>
              </Typography>
            )}
            <SignOutButton />
          </Toolbar>
        </Container>
      </AppBar>
      <br />
      <br />
      {children}
    </Box>
  );
};

export default NavBar;
